<template>
  <div style="padding-bottom: 20px;">
    <center style="padding-top: 100px;">
      <v-select
        v-if="config"
        :items="config"
        v-model="selectedToken"
        outlined
        item-text="name"
        item-value="id"
        style="max-width: 800px;" 
      />
      <!--p style="line-height:1;">
        <v-icon small style="margin-right: 10px;" color="red">mdi-alert</v-icon>
        <small style="color: orange;"><b>
          Esto es un PROTOTIPO y se encuentra en DESARROLLO !!! <br/> [ uso ORIENTATIVO ]
        </b></small>
      </p-->
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
        style="max-width: 800px;" 
      />
      <div>
        <preview
          v-if="selectedToken"
          :token="selectedToken"
        />
      </div>
    </center>
  </div>
</template>
<script>
import apiBrightsign from '@/services/apiBrightsign'
import Preview from './Preview'
export default {
  components: {
    Preview,
  }, 
  data: () => ({
    config: null,
    selectedToken: null,
    loading: false,
  }),
  computed: {
    id () {
      return this.$route.params.id
    },
    isDev () {
      return process.env.VUE_APP_ENV === 'development' ? true : false
    },
    width () {
      return 800
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    async handleGetData () {
      try {
        this.config = []
        this.loading = true
        this.config = await new Promise((resolve, reject) => apiBrightsign.getExternal(`/v1/public/brightsign/preview-list`, this.id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          }))
        this.loading = false

      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
  },
}
</script>


